import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'gsp-base-footer-layout',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class BaseFooterLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
